import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles/globals.css";
import { applyCachedBranding } from "./components/branding/BrandingProvider";

// Before the first paint (MPPI-00263). On a white-label domain the default
// brand is another company's colours, so a flash of it is worse here than the
// usual FOUC. Uses only what this hostname has shown before, so nothing can
// leak between tenants.
applyCachedBranding();
import { applyDocumentLanguage, useLanguageStore } from "@/store/languageStore";

// Auto-recover from stale bundle references after a deploy: when a tab
// loaded the previous index.js tries to lazy-import a chunk hash that no
// longer exists, Vite emits this event. A hard reload pulls the new
// index.js with current hashes and the navigation succeeds.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  window.location.reload();
});

// MPPI-00012 — set dir/lang before the first paint. Waiting for React would
// render the whole shell left-to-right and then flip it.
applyDocumentLanguage(useLanguageStore.getState().language);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
